import { OPEN_WIDGET } from 'calling-global-api/constants/EventListeners';
import { useEffect } from 'react';
import { getHsCalling } from '../utils/getHsCalling';
import { useComponentState } from 'navigation-components/consumer/hooks';
import { getPersistedCallProvider } from 'calling-lifecycle-internal/utils/getLocalCallSettings';
import CallingProvider from 'calling-internal-common/call-provider/records/CallingProvider';
import { isExtensionsInboundCallingEnabled } from 'calling-internal-common/utils/isExtensionsInboundCallingEnabled';
import { useUserInfo } from 'calling-ui-library/user-info/context/UserInfoContext';
export const useOpenProviderMenuEvent = ({
  openProviderMenu,
  showProviderMenu,
  setIsUserPreferencesProviderUnset,
  selectedCallProviderData
}) => {
  const {
    isOpen
  } = useComponentState();
  const {
    gates
  } = useUserInfo();
  useEffect(() => {
    const hsCalling = getHsCalling();
    const handleOpenWidget = payload => {
      const persistedProvider = getPersistedCallProvider();
      const isProviderMismatch = (persistedProvider === null || persistedProvider === void 0 ? void 0 : persistedProvider.name) !== selectedCallProviderData.name;
      setIsUserPreferencesProviderUnset(isProviderMismatch);
      const isInboundProviderMismatch = isProviderMismatch && isExtensionsInboundCallingEnabled(gates, new CallingProvider(persistedProvider)) && persistedProvider.supportsInboundCalling;
      const shouldShowProviderMenu = isInboundProviderMismatch || payload.showProviderMenu;
      if (!shouldShowProviderMenu) {
        return;
      }
      openProviderMenu();
    };
    hsCalling.addEventListener({
      event: OPEN_WIDGET,
      callback: handleOpenWidget
    });
    return () => {
      hsCalling.removeEventListener({
        event: OPEN_WIDGET,
        callback: handleOpenWidget
      });
    };
  }, [isOpen, openProviderMenu, showProviderMenu, selectedCallProviderData, setIsUserPreferencesProviderUnset, gates]);
};